export default __webpack_public_path__ + "static/media/shoe-women.095d3806.png";